var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Node as ProsemirrorNode } from 'prosemirror-model';
import { createDetachedElement } from './libs';
import { FORMAT_TYPE, SYL_TAG } from './schema';
/**
 * get & setHTML
 */
// check if there is an empty <p> in the last line of html in `setHTML`
var insertEmptyPTagAtTheEndOfHtml = function (div) {
    var lastChild = div.lastChild;
    if (!lastChild)
        return;
    if (lastChild.nodeName.toLocaleLowerCase() !== 'p' || lastChild.innerHTML !== '') {
        var blankP = document.createElement('p');
        div.appendChild(blankP);
        return;
    }
};
// remove the last `break`, and operate Node directly will cause the size to be incorrect and need to be corrected manually
var removeBrInEnd = function (doc) {
    var matchNodes = [];
    var topNode;
    var topPos = 0;
    doc.content.nodesBetween(0, doc.content.size, function (node, pos, _parent, index) {
        // set the new top Node
        if (!_parent) {
            topNode = node;
            topPos = pos;
        }
        if (node.isTextblock && node.lastChild && node.lastChild.type === node.type.schema.nodes.break) {
            var parent_1 = _parent || doc;
            var newNode = node.copy(node.content.cut(0, node.content.size - 1));
            // reverse to avoid incorrect position after modification
            matchNodes.unshift({ parent: parent_1, topNode: topNode, topPos: topPos, newNode: newNode, pos: pos, index: index });
            return false;
        }
    });
    matchNodes.forEach(function (_a) {
        var parent = _a.parent, _topNode = _a.topNode, _topPos = _a.topPos, newNode = _a.newNode, pos = _a.pos, index = _a.index;
        var $pos = _topNode.resolve(pos - _topPos); // border
        parent.content = parent.content.replaceChild(index, newNode);
        parent !== doc && doc.content.size--;
        var depth = $pos.depth - 2;
        while (depth >= 0) {
            $pos.node(depth).content.size--;
            depth--;
        }
    });
    return doc;
};
// `getHTML` remove the <br> at the end
var removeEmptyTagAtEndOfHtml = function (div) {
    var MARK = '<br>';
    var lastChild;
    do {
        lastChild = div.lastChild;
        if (!lastChild || lastChild.innerHTML !== MARK)
            break;
        lastChild.parentElement && lastChild.parentElement.removeChild(lastChild);
    } while (lastChild.innerHTML === MARK);
};
var IG_TAG = 'ignoretag';
var IG_EL = 'ignoreel';
var removeTag = function (el) {
    if (el.parentNode) {
        Array.from(el.childNodes).forEach(function (cNode) { return el.parentNode.insertBefore(cNode, el); });
        el.parentNode.removeChild(el);
    }
};
var removeIgnoreTag = function (div) {
    var ignoreTags = div.querySelectorAll("*[" + IG_TAG + "=true]");
    Array.from(ignoreTags)
        .reverse()
        .forEach(removeTag);
};
var removeIgnoreContent = function (div) {
    var ignoreEls = div.querySelectorAll("*[" + IG_EL + "=true]");
    Array.from(ignoreEls)
        .reverse()
        .forEach(function (el) {
        el.parentElement.removeChild(el);
    });
};
// remove <img class="ProseMirror-separator"> and .ProseMirror-trailingBreak
var handleHackNode = function (div) {
    Array.from(div.querySelectorAll('.ProseMirror-separator')).map(function (n) { var _a, _b; return (_b = (_a = n.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild) === null || _b === void 0 ? void 0 : _b.call(_a, n); });
    Array.from(div.querySelectorAll('.ProseMirror-trailingBreak')).forEach(function (n) { return n.removeAttribute('class'); });
};
// when <br> after `inlineCard` is the last node, delete it
var removeBrAfterInlineCard = function (div) {
    Array.from(div.querySelectorAll('br:last-child')).forEach(function (a) {
        var _a, _b, _c, _d;
        if (a.nextSibling || !a.previousSibling || a.previousSibling.nodeType !== 1)
            return;
        var prevNode = a.previousSibling;
        if (((_a = prevNode.matches) === null || _a === void 0 ? void 0 : _a.call(prevNode, 'syl-inline')) || ((_b = prevNode.querySelector) === null || _b === void 0 ? void 0 : _b.call(prevNode, 'syl-inline'))) {
            (_d = (_c = a.parentElement) === null || _c === void 0 ? void 0 : _c.removeChild) === null || _d === void 0 ? void 0 : _d.call(_c, a);
        }
    });
};
// merge continues <br>,<p><br></p>
var mergeContinuesEmptyLine = function (node) {
    var domRemoves = [];
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_ALL, {
        acceptNode: function (cNode) {
            if (cNode.nodeType === 1 || cNode.nodeType === 3) {
                return NodeFilter.FILTER_ACCEPT;
            }
            return NodeFilter.FILTER_REJECT;
        },
    });
    var prevTag = '';
    var isEmptyParagraph = function (p) {
        return p && p.nodeName === 'P' && (/^<br>+$/.test(p.innerHTML) || !p.innerHTML);
    };
    var judgeMerge = function (judgeNode) {
        var res = false;
        if (judgeNode.nodeName === 'BR' && prevTag === 'BR') {
            res = true;
        }
        else if (judgeNode.nodeType === 1 &&
            isEmptyParagraph(judgeNode) &&
            isEmptyParagraph(judgeNode.previousElementSibling)) {
            res = true;
        }
        prevTag = judgeNode.nodeName;
        return res;
    };
    while (walker.nextNode()) {
        var curNode = walker.currentNode;
        if (judgeMerge(curNode)) {
            domRemoves.push(curNode);
        }
    }
    domRemoves.forEach(function (dom) { return dom.parentNode && dom.parentNode.removeChild(dom); });
};
// use the content of `<templ>` to replace `SYL_TAG`
var removeShell = function (root) {
    var cards = root.querySelectorAll("[" + SYL_TAG + "]");
    [].slice.call(cards).forEach(function (card) {
        card.childNodes.forEach(function (child) {
            if (child.tagName === 'TEMPL' && card.parentElement) {
                card.parentElement.replaceChild(child, card);
                removeTag(child);
            }
        });
    });
    return root.innerHTML;
};
var transformGetHTML = function (html, sylPlugins) {
    var res = html;
    sylPlugins.forEach(function (_a) {
        var $controller = _a.$controller;
        if ($controller && $controller.transformGetHTML) {
            res = $controller.transformGetHTML(res);
        }
    });
    return res;
};
var handleDOMSpec = function (dom) {
    removeIgnoreTag(dom);
    removeIgnoreContent(dom);
    return dom;
};
var formatGetHTML = function (root, config, sylPlugins) {
    var div = createDetachedElement('div');
    var salt = String(Math.random()).substring(2, 8);
    div.hidden = true;
    div.innerHTML = root.innerHTML
        .replace(/(<[^>]*)(src=)/g, "$1data" + salt + "src=")
        .replace(/(<[^>]*)(draggable=[^\s|/|>]*\s?)/g, '$1')
        .replace(/(<[^>]*)(contenteditable=[^\s|/|>]*\s?)/g, '$1');
    handleDOMSpec(div);
    handleHackNode(div);
    removeBrAfterInlineCard(div);
    config && config.mergeEmpty && mergeContinuesEmptyLine(div);
    removeEmptyTagAtEndOfHtml(div);
    var pureHTML = function (html) { return html.replace(new RegExp("data" + salt + "src=", 'g'), 'src='); };
    var resHTML = pureHTML(removeShell(div));
    return transformGetHTML(resHTML, sylPlugins);
};
var formatSetHTML = function (html, config) {
    var div = createDetachedElement('div');
    div.innerHTML = html;
    // this replace break element with \n in codeblock
    handleDOMSpec(div);
    // used to avoid when `keepLastLine` is true, click after `setHTML` will cause emit confuse `text-change` event
    config.keepLastLine && insertEmptyPTagAtTheEndOfHtml(div);
    config.mergeEmpty && mergeContinuesEmptyLine(div);
    return div;
};
var getSplicedNode = function (node, start, end, newNode) {
    var plus = 0;
    var originText = node.text;
    var prevText = originText.substring(0, start);
    var nextText = originText.substring(end);
    var nodes = [];
    if (prevText) {
        nodes.push(__assign(__assign({}, node), { text: prevText }));
        plus++;
    }
    nodes.push(newNode);
    nextText && nodes.push(__assign(__assign({}, node), { text: nextText }));
    return { nodes: nodes, plus: plus };
};
var getMatchRules = function (sylPlugins) {
    var inlineMatchers = [];
    var blockMatchers = [];
    sylPlugins.forEach(function (_a) {
        var $schemaMeta = _a.$schemaMeta;
        if ($schemaMeta && $schemaMeta.config.textMatcher) {
            if ($schemaMeta.formatType === FORMAT_TYPE.INLINE_CARD) {
                $schemaMeta.config.textMatcher
                    .filter(function (r) { return r.inputOnly === false; })
                    .forEach(function (r) {
                    inlineMatchers.push({ name: $schemaMeta.name, matchRule: r });
                });
            }
            else if ($schemaMeta.formatType === FORMAT_TYPE.BLOCK_CARD) {
                $schemaMeta.config.textMatcher
                    .filter(function (r) { return r.inputOnly !== true; })
                    .forEach(function (r) {
                    blockMatchers.push({ name: $schemaMeta.name, matchRule: r });
                });
            }
        }
    });
    var matchNode = function (node, type) {
        if (type === void 0) { type = 'block'; }
        var curMatchRules = type === 'block' ? blockMatchers : inlineMatchers;
        for (var i = 0; i < curMatchRules.length; i++) {
            var _a = curMatchRules[i].matchRule, matcher = _a.matcher, handler = _a.handler;
            if (!handler)
                continue;
            var newMatchers = new RegExp(matcher.source, matcher.flags);
            var matched = newMatchers.exec(node.text);
            if (!matched)
                continue;
            var attrs = handler(matched);
            if (!attrs)
                continue;
            return {
                node: {
                    type: curMatchRules[i].name,
                    marks: node.marks,
                    attrs: attrs,
                },
                matchInfo: {
                    start: matched.index,
                    end: matched.index + matched[0].length,
                },
            };
        }
    };
    return { matchNode: matchNode, blockMatchers: blockMatchers, inlineMatchers: inlineMatchers };
};
// special HTML is transformed into `Node` through `textMatcher` config of `Schema`
var transformCard = function (docNode, view, sylPlugins) {
    var doc = docNode.toJSON();
    var _a = getMatchRules(sylPlugins), matchNode = _a.matchNode, blockMatchers = _a.blockMatchers, inlineMatchers = _a.inlineMatchers;
    doc = {
        type: 'doc',
        content: doc.content.map(function (node) {
            if (blockMatchers.length &&
                node.type === 'paragraph' &&
                node.content &&
                node.content.length === 1 &&
                node.content[0].type === 'text') {
                var res = matchNode(node.content[0]);
                if (res)
                    return res.node;
            }
            if (inlineMatchers.length && node.content) {
                var loopContent_1 = function (_content) {
                    for (var i = 0; i < _content.length; i++) {
                        var curNode = _content[i];
                        if (curNode && curNode.content) {
                            loopContent_1(curNode.content);
                        }
                        else if (curNode.text) {
                            var res = matchNode(curNode, 'inline');
                            if (res) {
                                var spliceNodeInfo = getSplicedNode(curNode, res.matchInfo.start, res.matchInfo.end, res.node);
                                _content.splice.apply(_content, __spreadArray([i, 1], spliceNodeInfo.nodes, false));
                                i += spliceNodeInfo.plus;
                            }
                        }
                    }
                };
                loopContent_1(node.content);
            }
            return node;
        }),
    };
    return ProsemirrorNode.fromJSON(view.state.schema, doc);
};
var parseHTML = function (html, adapter, config) {
    var _a = adapter.configurator, view = _a.view, basicConfiguration = _a.basicConfiguration;
    var htmlNode = formatSetHTML(html, __assign(__assign({}, basicConfiguration), config));
    var docNode = transformCard(
    // TODO：use parseSlice instead
    adapter.domParser.parse(htmlNode, {
        preserveWhitespace: config.keepWhiteSpace === undefined ? basicConfiguration.keepWhiteSpace : config.keepWhiteSpace,
    }), view, adapter.configurator.getSylPlugins());
    removeBrInEnd(docNode);
    return docNode;
};
export { formatGetHTML, formatSetHTML, handleDOMSpec, IG_EL, IG_TAG, insertEmptyPTagAtTheEndOfHtml, parseHTML, removeBrInEnd, transformCard, };
//# sourceMappingURL=formatter.js.map